import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ProductCenterView from '../views/ProductCenterView.vue'
import ProductDetailView from '../views/ProductDetailView.vue'
import SolutionCenterView from '../views/SolutionCenterView.vue'
import SolutionDetailView from '../views/SolutionDetailView.vue'
import CaseCenterView from '../views/CaseCenterView.vue'
import CaseDetailView from '../views/CaseDetailView.vue'
import NewsCenterView from '../views/NewsCenterView.vue'
import NewsDetailView from '../views/NewsDetailView.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'home', component: HomeView },
    { path: '/solutions', name: 'solutions', component: SolutionCenterView },
    {
      path: '/solutions/detail/:id',
      name: 'solution-detail',
      component: SolutionDetailView
    },
    { path: '/cases', name: 'cases', component: CaseCenterView },
    {
      path: '/cases/detail/:id',
      name: 'case-detail',
      component: CaseDetailView
    },
    { path: '/news', name: 'news', component: NewsCenterView },
    {
      path: '/news/detail/:id',
      name: 'news-detail',
      component: NewsDetailView
    },
    { path: '/products', name: 'products', component: ProductCenterView },
    {
      path: '/products/detail/:id',
      name: 'product-detail',
      component: ProductDetailView
    }
  ],
  scrollBehavior(to, _from, saved) {
    if (saved) return saved
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => resolve({ el: to.hash, behavior: 'smooth', top: 80 }), 100)
      })
    }
    return { top: 0, left: 0 }
  }
})

export default router
